// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"09f079f6e98de9b3","888":"961177a91d4e21bb"}[chunkId] + ".css";
};